import { render, staticRenderFns } from "./DragDropAnimation.vue?vue&type=template&id=22e3a70e&"
import script from "./DragDropAnimation.vue?vue&type=script&lang=js&"
export * from "./DragDropAnimation.vue?vue&type=script&lang=js&"
import style0 from "./DragDropAnimation.vue?vue&type=style&index=0&id=22e3a70e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports